export const version = "hdnode/5.4.0";
//# sourceMappingURL=_version.js.map